import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadProfile () {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/me/').then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateLanguage (lang) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch('/me/', { language: lang }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async changePassword (obj) {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/me/change-password/', obj).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateCompanyInfo (company) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/company/${company.slug}/`, company).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateUserProfile (user) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch('/me/', user).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async linkGoogleAccount (idToken) {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/auth/google/link/', { id_token: idToken }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async unlinkGoogleAccount () {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/auth/google/unlink/').then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
